export default __webpack_public_path__ + "static/media/logo.1ebdd006.svg";